enum LanguageType {
  EN = 'en',
  KO = 'ko',
}

export default LanguageType
